

/**
 * Use this component to set SEO metadata for a page
 * @param {String} title - name of the page
 * @param {String} description - metadescription of the page
 */
export default (title, description) => {
    document.getElementsByTagName('meta')["description"].content = description;
    document.getElementsByTagName('title')[0].innerText = title;
} 